import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { CorporateShell } from './CorporateShell';

const corporateShellWrapper = AppRootWrapperBlueprint.make({
  params: {
    component: CorporateShell,
  },
});

export const shellModule = createFrontendModule({
  pluginId: 'app',
  extensions: [corporateShellWrapper],
});
